import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

export const CardLabel = styled(Typography)(({ theme }) => ({
  display: '-webkit-box',
  WebkitLineClamp: '1',
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'normal',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  lineHeight: theme.spacing(2),
}));
